<template>
  <el-dialog :visible.sync="show" :width="width">
    <div class="findDialog">
      <div class="findDialog-searchForm">
        <el-form :inline="true" @submit.native.prevent>
          <div class="findDialog-searchItem__con">
            <el-form-item
              v-for="(item,index) in dialogData.searchItems"
              :key="index"
              :label="item.label"
              v-show="!item.hidden"
            >
              <el-input v-model="item.value" size="small"></el-input>
            </el-form-item>
          </div>
          <div class="findDialog-searchItem__operate">
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="findDialog-table">
        <el-table
          :data="tableData"
          v-loading="loading"
          @row-click="clickRow"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" :index="indexMethod" label="序号" width="55" align="center"></el-table-column>
          <el-table-column
            v-for="(item,index) in dialogData.searchTableItem"
            :key="index"
            :prop="item.key"
            :label="item.name"
            align="center"
          >
            <div slot-scope="scope">
              <span v-if="!item.type">{{scope.row[item.key]}}</span>
              <img
                v-if="item.type === 'image'"
                :src="scope.row[item.key]"
                width="40px"
                height="40px"
              />
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="findDialog-paging" v-show="pages > 1">
        <el-pagination
          layout="total,prev, pager, next"
          :current-page="formData.page_index"
          :page-count="pages"
          @current-change="handleCurrentChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <span slot="footer" class="findDialog-footer">
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
      <el-button size="small" @click="close">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import apis from "@/config/apis";
export default {
  data() {
    return {
      multipleSelection: [],
      new_data: [],
      new_name: [],
      formData: {
        page_index: 1,
        page_size: 10
      },
      total: 0,
      pages: 0,
      tableData: [],
      radio: false,
      loading: false,
      selectData: {}
    };
  },
  props: {
    dialogData: {
      searchItems: [
        {
          key: "搜索参数名称value",
          label: "搜索名称label",
          value: "既定参数",
          hidden: "是否默认删除"
        }
      ],
      searchTableItem: [
        {
          key: "表格参数名称value",
          name: "搜索表格参数label"
        }
      ],
      proxyLink: "搜索接口",
      proxyType: "接口类型"
    },
    show: Boolean,
    width: [String, Number]
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // let _data = [];
      // let _name = [];
      // for (let obj in this.multipleSelection) {
      //     _data.push(this.multipleSelection[obj].id);
      //     _name.push(this.multipleSelection[obj].name);
      // }
      // this.new_data = _data.join(',');//传给后台id
      // this.new_name = _name;//传进输入框名称
    },

    reset() {
      this.radio = "";
      this.formData.page_index = 1;
      this.dialogData.searchItems.forEach((item, index) => {
        if (!item.hidden) {
          this.formData[item.key] = "";
        } else {
          this.formData[item.key] = item.value;
        }
      });
      this.formData.page_index = 1;
      this.getData();
    },
    search() {
      this.dialogData.searchItems.forEach((item, index) => {
        this.formData[item.key] = item.value;
      });
      this.formData.page_index = 1;
      this.getData();
    },
    handleCurrentChange(value) {
      this.dialogData.searchItems.forEach((item, index) => {
        this.formData[item.key] = item.value;
      });
      this.formData.page_index = value;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.tableData = [];
      switch (this.dialogData.proxyType) {
        case "get":
          this.$axios
            .get(apis[this.dialogData.proxyLink], {
              params: this.formData
            })
            .then(res => {
              this.setData(res);
            });
          break;
        case "post":
          this.$axios
            .post(apis[this.dialogData.proxyLink], this.formData)
            .then(res => {
              this.setData(res);
            });
          break;
      }
    },
    setData(res) {
      if (res.data.code === 200) {
        let data,
          pagination = {};
        if (Array.isArray(res.data)) {
          data = res.data;
          pagination = res.pagination;
        } else if (Array.isArray(res.data.data)) {
          data = res.data.data;
          pagination = res.data.pagination;
        } else if (Array.isArray(res.data.data.data)) {
          data = res.data.data.data;
          pagination = res.data.data.pagination;
        }
        this.tableData = data;
        if (pagination) {
          this.formData.page_index = pagination.page_index;
          this.pages = pagination.page_count;
          this.total = pagination.total_count;
        }
      }
      this.loading = false;
    },
    indexMethod(index) {
      return (
        (this.formData.page_index - 1) * this.formData.page_size + index + 1
      );
    },
    confirm() {
      this.show = false;
      this.$emit("close", this.multipleSelection);
      // this.$emit('close', this.new_data, this.new_name)
    },
    close() {
      this.selectData = {};
      this.show = false;
    },
    //选中单行
    clickRow(row, event, column) {
      this.radio = row.id;
    }
  },
  watch: {
    show: function(value) {
      if (value) {
        this.selectData = {};
        this.search();
      }
    },
    "dialogData.proxyLink": function(value) {
      this.selectData = {};
      (this.formData = {
        page_index: 1,
        page_size: 10
      }),
        (this.pages = 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.findDialog-searchItem__con {
  float: left;
}

.findDialog-searchItem__operate {
  float: right;
}

.findDialog-paging {
  margin-top: 15px;
  text-align: right;
}

.findDialog-footer {
  text-align: right;
}
</style>
